module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Move_Black.5238ece6.svg";